<template>
  <a
    :href="link"
    target="_blank"
    download
    class="s-link primaryBlue--text"
    :class="{ mobile }"
  >
    <div class="s-link-text">
      <div class="color-primary-blue bold tile-title">{{ text }}</div>
      <div class="color-primary-purple" v-if="textBottom">
        {{ textBottom }}
      </div>
    </div>
    <div class="s-link-link">
      Więcej <v-icon class="ml-2 primaryBlue--text">mdi-arrow-right</v-icon>
    </div>
  </a>
</template>

<script>
export default {
  name: "LibHomeSectionFilesItem",
  props: {
    text: {
      type: String,
      default: ""
    },
    textBottom: {
      type: String,
      default: ""
    },
    link: {
      type: String,
      default: ""
    },
    mobile: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
.s-link {
  text-decoration: none;
  border: 1px solid;
  border-radius: 16px;
  padding: 15px 20px;
  // min-height: 120px;
  cursor: pointer;
  box-sizing: border-box;
  transition: 0.1s box-shadow;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  .v-icon {
    transition: 0.2s transform;
  }
  &:hover {
    box-shadow: inset 0px 0px 0px 2px;
    .v-icon {
      transform: translateX(3px);
    }
  }

  .tile-title {
    font-size: 1.125rem;
  }

  .s-link-text {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }
  .s-link-link {
    display: flex;
    align-items: center;
  }
}
.s-link.mobile {
  min-height: 72px;
}
</style>
